export default "<main-layout>\n    <router-outlet></router-outlet>\n</main-layout>"